<template>
    <header id="header">
        <top-bar></top-bar>
        <inner-header></inner-header>
        <nav-bar :data="menu_items"></nav-bar>
    </header>
</template>

<script>
    import TopBar from './TopBar.vue'
    import InnerHeader from "./InnerHeader";
    import NavBar from './NavBar'
    import { mapGetters, mapActions } from 'vuex'

    export default {
        name: 'Home',
        data() {
            return {
                menu_items: this.getMenuItems,
            }
        },
        components: {
            InnerHeader,
            TopBar,
            NavBar
        },
        computed: {
            ...mapGetters([
                'getMenuItems',
            ])
        },
        methods: {
            ...mapActions([

            ])
        },
        mounted() {
            this.$store.dispatch('getMenuItems');
        },
        watch: {
            getMenuItems: function(newVal) {
                this.menu_items = newVal;
            }
        }
    }
</script>

<style lang="scss">

</style>
